import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';

import { TableButton } from '../../interfaces/object-interfaces';

@Component({
    selector: 'pro-table-dialog',
    template: `
        <pro-dialog-title [title]="data.header"></pro-dialog-title>
        <div mat-dialog-content>
            <pro-table [config]="data.config" [timeStamp]="timestamp" [dataSource]="data.payload"></pro-table>
        </div>
        <pro-dialog-actions></pro-dialog-actions>
    `
})

export class TableDialogComponent {
    timestamp: number;

    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
        public dialogRef: MatLegacyDialogRef<TableDialogComponent>
    ) {
        if (this.data?.config?.addButton) {
            this.data.config.addButton.onSuccess = this.refresh;
            this.data.config.addButton.onCancel = this.refresh;
        }

        if (this.data?.config?.rowButtons) {
            this.data.config.rowButtons.forEach((button: TableButton) => {
                button.onSuccess = this.refresh;
                button.onCancel = this.refresh;
            })
        }
    }

    refresh = () => {
        this.timestamp = new Date().getTime();
    }
}
